'use strict';

import React, { useCallback, useEffect, useRef, useState } from 'react'

import _ from 'lodash'

import PageWrapper from '@Layout/PageWrapper'
import Layout      from '@Layout/BackOffice'

import HolidaysMessage from '@/HolidaysMessage'

import getFormData from '@/Form/Functions/getFormData'
import FileInputV2 from '@/Form/toolkit/FileInputV2'
import ModelPicker from '@/Form/V2/ModelPicker'

import ProductRefDetails from '@/ProductRefDetails'

import getFormStatus from '@/Form/Functions/getFormStatus'

import Loader from '@Pure/Loader'

import bemit from '@function/bemit'

import ajaxRequest from '@function/ajax/ajaxRequest'

const { app } = window;

const dashboard_link = '/gestion-des-commandes/codes-promo';

const FORM_NAME = 'DiscountCodeImport';

export default PageWrapper(function DiscountCodesImportPage (props)
{
	const file_ref = useRef();

	const [upload_id, setUploadId] = useState(1);
	const [form_data, setFormData] = useState({ });
	const [loading, setLoading] = useState(false);
	const [status, setStatus] = useState({ status_messages: { } });

	const handleFileChange = useCallback(function (e, data)
	{
		let name = data.name;

	// Binaires
		const __files = (form_data['__files-' + name] || [])
		.filter(function (file)
		{
			return file.form_name !== data.name;
		});

		if (data && data.value instanceof Array && data.value[0])
		{
			__files.push(data.value[0]);
		}

	// Informations
		const files_infos = (form_data[name] || [])
		.filter(function (file)
		{
			return file.form_name !== data.name;
		});

		if (data && data.value instanceof Array && data.value[0])
		{
			let infos = _.cloneDeep(data.value[0]);

			delete infos.file;
			delete infos.pdf;
			delete infos.image;

			files_infos.push(infos);
		}

		setFormData(
		{
			...form_data,

			['__files-' + name]: __files,
			[name]: files_infos,

			'__attachments': files_infos || []
		});
	},
	[form_data]);

	const codes_ref = status.ref;

	const showCodes = useCallback(function (e)
	{
		e.preventDefault();

		window.localStorage.setItem('DiscountCodesList.searched', codes_ref);

		try
		{
			app.router_history.push(dashboard_link);
		}
		catch (e)
		{
			window.location.pathname = dashboard_link;
		}
	},
	[codes_ref]);

	let validate_btn_modifiers = ['extra'];

	if (status.info || !form_data.import?.length > 0  || !form_data.ref)
	{
		validate_btn_modifiers.push('disabled');
	}

	const loader = loading === true ?
	(
		<Loader className="c-loader" bemit={ ['white', 'bg-primary'] } />
	)
	: undefined;

	const errors = (status.errors || []).map(function (data, key)
	{
		return (
			<div key={ key + data.line }>
				{
					getFormStatus(
						{ error: 'Ligne ' + data.line + '. ' + data.error },
						{ style: { marginTop: 5, marginBottom: 5 }
					})
				}
			</div>
		);
	});

	return (
		<Layout page_title="Import de codes promo" history={ props.history }>

			<div className="page-content">
				<HolidaysMessage />

				<div className="c-paper">

					<div className="o-grid-2">

						<div className="o-grid__item">

							<ModelPicker name="ref"
								label="Ref. prix produit"
								model="ProductRef"
								error={ status.fields?.['ref']?.error }
								bemit={ ['100%', 'import-promo-refs'] }
								form={ FORM_NAME }
								url="/autocomplete/products-refs"
								onChange={ handleChange }
								value={ form_data.ref }
							/>

						</div>

						<div className="o-grid__item u-flex u-items-center"
							ref={ file_ref }>
							{
								form_data.ref ?
								(
									<FileInputV2 label="Sélection des codes"
										key={ String(upload_id) }
										name="import" multiple={ false }
										onChange={ handleFileChange }
										data={ form_data }
										status={ status.status_messages }
										button_txt="Ajouter ou modifier le fichier d'import"
										accept=".csv, .txt, .xlsx"
									/>
								)
								: undefined
							}
						</div>

					</div>

					{
						form_data.ref ?
						(
							<ProductRefDetails product_ref={ form_data.ref } />
						)
						: undefined
					}

				</div>

				<div className="u-full-width u-margin-top-20">

					<button type="button"
						disabled={ validate_btn_modifiers.includes('disabled')}
						className={ bemit('c-btn', validate_btn_modifiers) }
						onClick={ validate }>
						Importer ces codes
						{ loader }
					</button>

				</div>

				{
					status.ref ?
					(
						<div className={ bemit('c-form-message', ['green']) }>
							<div className="c-form-message__content">
								{ status.info }
								{ ' ' }
								<a href={ dashboard_link } onClick={ showCodes }>
									Afficher les codes importés.
								</a>
							</div>
						</div>
					)
					: getFormStatus(status)
				}

				{ errors }

			</div>

		</Layout>
	);

	async function validate (e)
	{
		setLoading(true);

		const data = getFormData({ state: form_data });

		try
		{
			var response = await ajaxRequest('/import/discount-codes-file',
			{
				data: data,
				axios_params: { timeout: 5 * 60 * 1000 }
			});

			response.status_messages ||= { };
		}
		catch (update)
		{
			setLoading(false);
			setUploadId(id => id+1);

			return setStatus(update);
		}

		setUploadId(id => id+1);
		setStatus(response);
		setFormData({ '__files-import': [], import: [] });
		setLoading(false);

		if (file_ref.current)
		{
			const input = file_ref.current.querySelector('input[type="file"]');

			if (input) input.value = '';
		}
	}

	function handleChange ({ e, name, value })
	{
		if (form_data[name] === value) return;

		const status_messages = { ...(status.status_messages || { }) };

		status_messages[name] = status_messages[name] || { };

		status_messages[name].error   = undefined;
		status_messages[name].info    = undefined;
		status_messages[name].warning = undefined;

		setStatus(
		{
			...status,

			ref: undefined,

			status_messages: status_messages,

			info: undefined,
			error: undefined,
			warning: undefined,

			errors: undefined
		});

		setFormData(function (form_data)
		{
			return { ...form_data, [name]: value };
		});
	}
});